import { useEffect, useState, useContext, useRef, useCallback } from "react";
import axios from "axios";
import { DarkModeContext } from "../context/DarkModeContext";
import { BACKEND_URL } from "../utils";
import { motion } from "framer-motion";
import gsap from "gsap";

const Product = () => {
  const { darkMode } = useContext(DarkModeContext);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    quantity: "",
    price: "",
  });

  const [editingId, setEditingId] = useState(null);

  const token = localStorage.getItem("token");

  // 🔥 FETCH
  const fetchProducts = useCallback(async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/products`, {
        headers: { "x-auth-token": token },
      });
      setProducts(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // 🔥 DELETE
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BACKEND_URL}/api/products/${id}`, {
        headers: { "x-auth-token": token },
      });

      setProducts(products.filter((p) => p._id !== id));
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  // 🔥 EDIT CLICK
  const handleEdit = (product) => {
    setFormData(product);
    setEditingId(product._id);
  };

  // 🔥 INPUT CHANGE
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 🔥 ADD / UPDATE
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await axios.put(
          `${BACKEND_URL}/api/products/${editingId}`,
          formData,
          { headers: { "x-auth-token": token } }
        );
      } else {
        await axios.post(`${BACKEND_URL}/api/products`, formData, {
          headers: { "x-auth-token": token },
        });
      }

      setFormData({ name: "", category: "", quantity: "", price: "" });
      setEditingId(null);
      fetchProducts();
    } catch (err) {
      console.error("Save error", err);
    }
  };

  if (loading) return <p className="text-center mt-10">Loading...</p>;

  return (
    <div className="p-4">

      {/* FORM */}
      <form onSubmit={handleSubmit} className="mb-6 space-y-2">
        <input name="name" value={formData.name} onChange={handleChange} placeholder="Name" className="border p-2 w-full" />
        <input name="category" value={formData.category} onChange={handleChange} placeholder="Category" className="border p-2 w-full" />
        <input name="quantity" value={formData.quantity} onChange={handleChange} placeholder="Quantity" className="border p-2 w-full" />
        <input name="price" value={formData.price} onChange={handleChange} placeholder="Price" className="border p-2 w-full" />

        <button className="bg-indigo-600 text-white px-4 py-2">
          {editingId ? "Update Product" : "Add Product"}
        </button>
      </form>

      {/* LIST */}
      {products.map((p) => (
        <div key={p._id} className="border p-3 mb-2 flex justify-between">
          <div>
            <h2>{p.name}</h2>
            <p>{p.category}</p>
          </div>

          <div className="space-x-2">
            <button
              onClick={() => handleEdit(p)}
              className="bg-blue-500 text-white px-3 py-1"
            >
              Edit
            </button>

            <button
              onClick={() => handleDelete(p._id)}
              className="bg-red-500 text-white px-3 py-1"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Product;